export const messages = {
  en: {
    productImport: {
      title: 'Product Information',
      selectFile: 'Select File',
      fileRequired: 'Required, please select data file',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark information',
      template: 'Template',
      import: 'Import',
      fileTypeError: 'Invalid Excel format',
      fileSizeError: 'Excel file size cannot exceed 2M',
      shopRequired: 'Not settled in community yet, please settle first',
      success: 'Processed successfully'
    }
  },
  zh: {
    productImport: {
      title: '商品信息',
      selectFile: '选择文件',
      fileRequired: '必填，请选择数据文件',
      remark: '备注',
      remarkPlaceholder: '请填写备注信息',
      template: '模板',
      import: '导入',
      fileTypeError: '不是有效的Excel格式',
      fileSizeError: 'Excel文件大小不能超过2M',
      shopRequired: '还未入驻小区，请先入驻小区',
      success: '处理成功'
    }
  }
}